<template>
  <div class="rating-stars">
    <rating-stars :percent="percent" />
    <em>
      {{ average | toFixed(1) }} <template v-if="showAverage">({{ ratingCount }})</template>
      <span class="d-sm-inline-block">{{ description }}</span>
    </em>
    <div
      v-if="extendedAverage"
      v-dompurify-html="$t('rating:count.extended', { count: ratingCount })"
    />
  </div>
</template>
<script>
import RatingStars from 'components/RatingStars.vue';

export default {
  name: 'RatingStarsCanvas',
  components: {
    RatingStars,
  },
  i18nOptions: { namespaces: ['rating'] },
  props: {
    average: {
      type: Number,
      required: true,
    },
    description: {
      default: '',
      type: String,
      required: false,
    },
    showAverage: {
      type: Boolean,
      default: false,
    },
    extendedAverage: {
      type: Boolean,
      default: false,
    },
    ratingCount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    percent() {
      return (this.average / 5) * 100;
    },
  },
};
</script>
